var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 13.25C0.5375 13.25 0.3595 13.178 0.216 13.034C0.0725001 12.89 0.0005 12.712 0 12.5C0 12.2875 0.0720001 12.1095 0.216 11.966C0.36 11.8225 0.538 11.7505 0.75 11.75H1.5V6.5C1.5 5.4625 1.8125 4.54075 2.4375 3.73475C3.0625 2.92875 3.875 2.4005 4.875 2.15V1.625C4.875 1.3125 4.9845 1.047 5.2035 0.8285C5.4225 0.61 5.688 0.5005 6 0.5C6.3125 0.5 6.57825 0.6095 6.79725 0.8285C7.01625 1.0475 7.1255 1.313 7.125 1.625V2.15C8.125 2.4 8.9375 2.92825 9.5625 3.73475C10.1875 4.54125 10.5 5.463 10.5 6.5V11.75H11.25C11.4625 11.75 11.6407 11.822 11.7847 11.966C11.9287 12.11 12.0005 12.288 12 12.5C12 12.7125 11.928 12.8907 11.784 13.0347C11.64 13.1787 11.462 13.2505 11.25 13.25H0.75ZM6 15.5C5.5875 15.5 5.2345 15.3533 4.941 15.0597C4.6475 14.7662 4.5005 14.413 4.5 14H7.5C7.5 14.4125 7.35325 14.7657 7.05975 15.0597C6.76625 15.3538 6.413 15.5005 6 15.5ZM3 11.75H9V6.5C9 5.675 8.70625 4.96875 8.11875 4.38125C7.53125 3.79375 6.825 3.5 6 3.5C5.175 3.5 4.46875 3.79375 3.88125 4.38125C3.29375 4.96875 3 5.675 3 6.5V11.75Z",
    fill: "#848A9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSmall);
export default __webpack_public_path__ + "static/media/notificationSmall.06dc8c96683667958eef69c4edcfa8f3.svg";
export { ForwardRef as ReactComponent };